import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '../../environments/environment';
import { UserService } from '../Services/user.service';
@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css',
  providers : [UserService]
})
export class AdminComponent implements OnInit {
  version: string = '';
  role: string | null = null;
  constructor(private userService: UserService) {
    this.version = environment.version;
  }

  ngOnInit(): void {
    this.role = this.userService.checkRole();
    console.log('Current user\'s role:', this.role);
    console.log('user: ',this.userService.getCurrentUsername());
  }
  hasAccess(routes: string[]): boolean {
    return !!this.role && routes.includes(this.role);
    // if (!this.role) return false;
    // const normalizedRole = this.role.toLowerCase();
    // return routes.some((route) => route.toLowerCase() === normalizedRole);
  }
}
